//#region src/utils/recent-ids/merge-recent-ids.ts
/**
* Merge per-region "recent id" buckets into one ordered, de-duplicated list.
* Used to present recents across all accessible regions (Portal) instead of
* a single selected region. First occurrence wins; ordering is bucket order.
*/
function mergeRecentIds(buckets) {
	const seen = /* @__PURE__ */ new Set();
	const result = [];
	for (const ids of buckets) {
		if (!ids) continue;
		for (const id of ids) if (!seen.has(id)) {
			seen.add(id);
			result.push(id);
		}
	}
	return result;
}
//#endregion
export { mergeRecentIds };

//# sourceMappingURL=merge-recent-ids.js.map